<template>
  <div id="app" class="container">
    <header v-if="isHome">
      <img src="img/header.svg" alt="">
    </header>
    <header v-else class="has-text-centered">
      <div class="park has-text-weight-medium">せたがやガーデニングフェア2022</div>
      <h1 class="has-text-weight-bold">QRスタンプラリー</h1>
    </header>

    <router-view/>

    <footer class="has-text-weight-light">
      <a href="https://www.aboc.co.jp" target="_blank">
        <img src="img/footer.svg" alt="">
      </a>
      <span class="version">ver.0.6.6</span>
    </footer>

    <HighlightStamp/>
    <CompleteScreen/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import HighlightStamp from './components/HighlightStamp.vue';
import CompleteScreen from './components/CompleteScreen.vue';

export default {
  name: 'App',
  components: {
    HighlightStamp,
    CompleteScreen,
  },
  computed: {
    ...mapState(['showComplete']),
    ...mapGetters(['completed']),
    isHome() {
      return this.$route.name === 'home';
    },
  },

  created() {
    // 貯めたスタンプをロードする
    this.$store.dispatch('loadStamps');
  },

  mounted() {
    // URLパラメータからスタンプをリセットする
    const { query } = this.$router.currentRoute;
    if ('reset' in query) {
      window.dataLayer.push({ event: 'reset_stamps' }); // gtm
      this.$store.dispatch('clearStamps');
    }

    // URLパラメータからスタンプを追加する
    if ('stamp' in query) {
      const id = query.stamp;
      if (this.validId(id)) {
        window.dataLayer.push({ event: 'get_stamp', stamp: id }); // gtm
        this.$store.commit('updateCurrentId', { id });
        // ハイライトアニメーションがかかるので、4.5秒以上まってから保存する
        window.setTimeout(() => {
          this.$store.dispatch('addStamp', { id }); // &セーブ付き
          this.$store.commit('clearCurrentId'); // ここで初期化しておく（連続読み込みに対応するため）
        }, 4500);
      }
    }
  },

  methods: {
    validId(id) {
      const stamp = this.$store.state.stamps.find((s) => s.id === id);
      return !!stamp;
    },
  },

  watch: {
    completed(bool) {
      if (bool) {
        // 全スタンプがそろった
        console.log('completed!');
        window.dataLayer.push({ event: 'completed' }); // gtm
        window.setTimeout(() => {
          this.$store.commit('updateShowComplete', true);
        }, 1600); // 遅延させている
      }
    },
  },
};
</script>

<style lang="scss"></style>
